import { MotorSensoryAssessmentConstants } from './motoSensoryAssessment.constants'
import { IMotorSensoryAssessmentAction, IMotorSensoryAssessmentState } from './motoSensoryAssessment.types'

export const initialMotorSensoryAssessmentState: IMotorSensoryAssessmentState = {
  motorLa: null,
  motorRa: null,
  motorLl: null,
  motorRl: null,
  sensoryLa: null,
  sensoryRa: null,
  sensoryLl: null,
  sensoryRl: null,
  motorComments: '',
  headSensory: '',
  motorSensoryState: null,
}

export function motorSensoryAssessmentReducer(
  state: IMotorSensoryAssessmentState = initialMotorSensoryAssessmentState,
  action: IMotorSensoryAssessmentAction
): IMotorSensoryAssessmentState {
  switch (action.type) {
    case MotorSensoryAssessmentConstants.SET_MOTORLA:
      return { ...state, motorLa: action.motorLa }
    case MotorSensoryAssessmentConstants.SET_MOTORRA:
      return { ...state, motorRa: action.motorRa }
    case MotorSensoryAssessmentConstants.SET_MOTORLL:
      return { ...state, motorLl: action.motorLl }
    case MotorSensoryAssessmentConstants.SET_MOTORRL:
      return { ...state, motorRl: action.motorRl }
    case MotorSensoryAssessmentConstants.SET_SENSORYLA:
      return { ...state, sensoryLa: action.sensoryLa }
    case MotorSensoryAssessmentConstants.SET_SENSORYRA:
      return { ...state, sensoryRa: action.sensoryRa }
    case MotorSensoryAssessmentConstants.SET_SENSORYLL:
      return { ...state, sensoryLl: action.sensoryLl }
    case MotorSensoryAssessmentConstants.SET_SENSORYRL:
      return { ...state, sensoryRl: action.sensoryRl }
    case MotorSensoryAssessmentConstants.SET_MOTORCOMMENTS:
      return { ...state, motorComments: action.motorComments }
    case MotorSensoryAssessmentConstants.SET_HEADSENSORY:
      return { ...state, headSensory: action.headSensory }

    case MotorSensoryAssessmentConstants.SET_MOTOR_SENSORY:
      return { ...state, ...action.motorSensory }
    case MotorSensoryAssessmentConstants.RESET_MOTOR_SENSORY_STATE:
      return { ...state, ...initialMotorSensoryAssessmentState }
    case MotorSensoryAssessmentConstants.SET_MOTOR_SENSORY_STATE:
      return { ...state, motorSensoryState: action.motorSensoryState }

    default:
      return state
  }
}
